<template>
  <div>
    <div class="header-a">
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item title="一、如何开始“易停车”？" name="1">
          微信/支付宝搜索“易停车”公众号或扫描停车场的二维码，打开后输入车牌号码，点击“查询”可获得停车信息，如要出场可直接缴费，完成缴费平台可给车主推送本次停车信息
        </van-collapse-item>
        <van-collapse-item title="二、易停车有没有优惠？" name="2">
          办理月卡，可以享受折扣优惠和充值优惠。
        </van-collapse-item>
        <van-collapse-item title="三、巡检员可以直接收费吗？" name="3">
          严禁巡查员主动收取停车费。巡查员只履行流动巡查、规范停车引导、车牌录入的职责。若车主用户无法使用线上支付，可将现金交由巡查员代缴停车费。
        </van-collapse-item>
        <van-collapse-item title="四、车主该如何取车？" name="4">
          车主要取车时，直接开车驶离车位，停车设备会自动识别停车计费，然后在平台推送的账单信息里缴纳停车费即可。不必担心取车时通信信号不好。
        </van-collapse-item>
        <van-collapse-item title="五、易停车支持哪些收费方式？" name="5">
          易停车公众号支持微信支付、支付宝支付、银联支付等线上支付方式。方便又安全。
        </van-collapse-item>
        <van-collapse-item title="六、如何开具发票？" name="6">
          需要电子发票，打开“易停车”公众号，进入发票申请页面，选择要开票的消费记录，填写好发票抬头和邮箱，点击确认开票即可。
        </van-collapse-item>
        <van-collapse-item title="七、没有线上缴费渠道如何缴费？" name="7">
          无法线上缴费时，可将现金交予巡查员委托代缴停车费，外地车辆同样扫描二维码即可缴费。
        </van-collapse-item>
        <van-collapse-item title="八、是不是每次停车都需要扫码？" name="8">
          不需要。车主通过关注“易停车”公众哈，绑定车牌后即可实现自动推送订单、预约车位、停车自助缴费等操作。
        </van-collapse-item>
        <van-collapse-item title="九、新能源车能使用“易停车”吗？" name="9">
          可以。绑定车牌的时候完整输入车牌信息，“易停车”支持绿牌车和蓝牌车使用。  
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "",
    };
  },
  created() {},
  methods: {},
};
</script>

<style scoped>
.header-a {
  margin: 30px;
}

/deep/.header-a .van-cell {
  height: 80px;
  line-height: 60px;
  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

/deep/.header-a .van-cell__title {
  width: 20px;
}

/deep/.header-a .van-collapse-item {
  margin: 30px 0;
}

/deep/.header-a .van-cell__title span {
  font-size: 33px;
}

/deep/.header-a .van-collapse-item__content {
  font-size: 33px;
}

/deep/.header-a .van-cell__right-icon {
  font-size: 33px;
  line-height: 60px;
}
</style>


// WEBPACK FOOTER //
// src/pages/problem.vue